/*
  CHEZ NOUS. — Synchronisation du bouton de pré-commande avec le stock.

  Deux scripts réécrivent le libellé du bouton d'ajout au panier après coup :
  - le thème Dawn, qui se contente de réactiver le bouton et d'y remettre "Ajouter au panier"
    au lieu de re-rendre le libellé calculé en Liquid ;
  - l'application Timesact, installée sur la boutique, qui remet elle aussi son propre libellé
    quelques centaines de millisecondes après chaque changement de taille.

  Ce script rétablit donc le libellé et la mention de délai rendus par le serveur
  (voir snippets/buy-buttons.liquid) après chaque changement de variante, puis surveille le
  bouton pour les réappliquer si quelque chose les écrase. Il n'intervient que sur les pièces
  en pré-commande : hors pré-commande, il laisse le bouton totalement tranquille.
*/
(function () {
  if (window.CN_PREORDER_SYNC) return;
  window.CN_PREORDER_SYNC = true;

  var PREORDER_CLASS = 'product-form__submit--preorder';
  var watched = new Map();

  function labelSpan(button) {
    return button ? button.querySelector('span') : null;
  }

  function enforce(button) {
    var entry = watched.get(button);
    if (!entry || !entry.label) return;

    var span = labelSpan(button);
    if (span && span.textContent.trim() !== entry.label) {
      span.textContent = entry.label;
    }
    if (!button.classList.contains(PREORDER_CLASS)) {
      button.classList.add(PREORDER_CLASS);
    }
    if (entry.note && entry.noteText) {
      if (entry.note.textContent.trim() !== entry.noteText) {
        entry.note.textContent = entry.noteText;
      }
      entry.note.classList.remove('hidden');
    }
  }

  function track(button, note, label, noteText) {
    var entry = watched.get(button);

    if (!entry) {
      entry = { label: null, note: note, noteText: '', observer: null };
      entry.observer = new MutationObserver(function () {
        enforce(button);
      });
      entry.observer.observe(button, { childList: true, characterData: true, subtree: true });
      watched.set(button, entry);
    }

    entry.note = note;
    entry.label = label;
    entry.noteText = noteText;

    if (label) {
      enforce(button);
    }
  }

  function applyFromDocument(info, sourceDoc, sourceSectionId) {
    var suffix = info.dataset.section;

    var sourceButton = sourceDoc.getElementById('ProductSubmitButton-' + sourceSectionId);
    var targetButton = info.querySelector('#ProductSubmitButton-' + suffix);
    if (!sourceButton || !targetButton) return;

    var sourceNote = sourceDoc.getElementById('Preorder-Note-' + sourceSectionId);
    var targetNote = info.querySelector('#Preorder-Note-' + suffix);

    var isPreorder = sourceButton.classList.contains(PREORDER_CLASS);
    var sourceLabelSpan = labelSpan(sourceButton);
    var label = isPreorder && sourceLabelSpan ? sourceLabelSpan.textContent.trim() : '';
    var noteText = sourceNote ? sourceNote.textContent.trim() : '';

    if (targetNote) {
      targetNote.textContent = noteText;
      targetNote.classList.toggle('hidden', noteText === '');
    }

    if (isPreorder && label && !targetButton.hasAttribute('disabled')) {
      track(targetButton, targetNote, label, noteText);
    } else {
      targetButton.classList.remove(PREORDER_CLASS);
      track(targetButton, targetNote, null, '');
    }
  }

  function initialPass() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var suffix = info.dataset.section;
      var button = info.querySelector('#ProductSubmitButton-' + suffix);
      var note = info.querySelector('#Preorder-Note-' + suffix);
      if (!button || !button.classList.contains(PREORDER_CLASS)) return;

      var span = labelSpan(button);
      track(button, note, span ? span.textContent.trim() : '', note ? note.textContent.trim() : '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialPass);
  } else {
    initialPass();
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = (event && event.data) || {};
    if (!data.html || !data.sectionId) return;

    document.querySelectorAll('product-info').forEach(function (info) {
      var infoSectionId = info.dataset.originalSection || info.dataset.section;
      if (infoSectionId !== data.sectionId) return;
      applyFromDocument(info, data.html, data.sectionId);
    });
  });
})();
